var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_ATTRIBUTES = {
  role: "img",
  "aria-hidden": "true"
};
export default function icon(iconKey, attributes = {}) {
  const iconAttributes = __spreadValues(__spreadValues({}, DEFAULT_ATTRIBUTES), attributes);
  const htmlAttributes = { width: "1em", height: "1em" };
  Object.keys(iconAttributes).forEach((key) => {
    const newKey = key.replace(/([A-Z])/g, (ucw) => `-${ucw[0].toLowerCase()}`);
    if (typeof htmlAttributes[key] === "undefined") {
      htmlAttributes[newKey] = iconAttributes[key];
    } else {
      htmlAttributes[newKey] = `${htmlAttributes[newKey]} ${iconAttributes[key]}`;
    }
  });
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
  const title = document.createElement("title");
  title.innerHTML = iconAttributes.title || iconAttributes.ariaLabel || iconKey;
  use.setAttributeNS(null, "href", `${window.Decidim.config.get("ow_icons_path")}#ow-${iconKey}`);
  Object.entries(htmlAttributes).forEach(([key, value]) => svg.setAttribute(key, value));
  svg.appendChild(title);
  svg.appendChild(use);
  return svg;
}
